import React, { Component } from "react";
import PropTypes from "prop-types";
import { ShowFullscreenLoader } from "../FullscreenLoader";
import AuthenticatedRoute from "./AuthenticatedRoute";
import { connect } from "react-redux";
import { isValidElementType } from "react-is";

class AuthenticatedRouteContainer extends Component {
  static propTypes = {
    requiredRole: PropTypes.string.isRequired,
    onlyVerified: PropTypes.bool,
    component: (props, propName) => {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
  };

  render() {
    const {
      component, isTokenExist, userRoles, isAuthorizing,
      requiredRole, onlyVerified, ...rest
    } = this.props;


    if (isAuthorizing) {
      return <ShowFullscreenLoader />;
    }

    return (
      <AuthenticatedRoute component={component}
                          requiredRole={requiredRole}
                          isTokenExist={isTokenExist}
                          userRoles={userRoles}
                          signInUrl={"/login/auth"}
                          onlyVerified={onlyVerified}
                          {...rest}
      />
    );
  }
}

export default connect(({ authorization }) => ({
  isTokenExist: !!authorization?.iat,
  userRoles: authorization?.roles,
  isAuthorizing: authorization?.isFetching,
}))(AuthenticatedRouteContainer);
